export default __webpack_public_path__ + "static/media/blocker_logo.7221ec07.png";